import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_pharmacy-360")({
  component: PharmacyLayout,
});

function PharmacyLayout() {
  return (
    <RequirePermission permission="pharmacy_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
